import { useEffect } from 'react'
import { AuthTokens } from '../../types'
import { ApiAuthActionsState } from '../useApiAuthActions'

export const useRefreshAccessTokenState = (
  accessTokenRef: AuthTokens['accessTokenRef'],
  fetchAccessToken: ApiAuthActionsState['fetchAccessToken']
) => (
  useEffect(() => {
    const refetchAt = accessTokenRef?.current?.refetchAt
    if (refetchAt === undefined) return
    const nextRefresh = Math.max(refetchAt - Date.now(), 0)
    const timeout = setTimeout(fetchAccessToken, nextRefresh)
    return () => { clearTimeout(timeout) }
  }, [accessTokenRef, fetchAccessToken])
)
